export class Step12 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step11';
    gettyperensa = 'form.mapa_in.typerensa';
    getpersonnemorale = 'form.mapa_in.getpersonnemorale';
    getnum = 'form.mapa_in.getnum';
    getposte = 'form.mapa_in.getposte';
    getcivilite = 'form.mapa_in.getcivilite';
    getcp = 'form.mapa_in.getcp';
    getpren = 'form.mapa_in.getpren';
    gettel = 'form.mapa_in.gettel';
    getnom = 'form.mapa_in.getnom';
    getnomvoie = 'form.mapa_in.getnomvoie';
    getfonc = 'form.mapa_in.getfonc';
    getmel = 'form.mapa_in.getmel';
    getpays = 'form.mapa_in.getpays';
    gettypevoie = 'form.mapa_in.gettypevoie';
    geturl = 'form.mapa_in.geturl';
    getcp_e = 'form.mapa_in.getcp_e';
    getfax = 'form.mapa_in.getfax';
    getville = 'form.mapa_in.getville';
    add = 'boutons.add';
    remove = 'boutons.remove';

}
